module.exports = __webpack_public_path__ + "static/media/index.36238589.less";